import Validator from 'validatorjs';
import { t, lang } from 'helpers/i18n';
// Load required languages (en loaded by default)
Validator.setMessages('es', require('validatorjs/src/lang/es'));
Validator.useLang(lang);
Validator.setAttributeFormatter(attribute => t(attribute.replace(/.+\./, '')));
export class Validation {
    constructor(values, schema) {
        this.validator = new Validator(values, this.parseSchema(schema));
    }
    get valid() {
        return this.validator.passes();
    }
    get errors() {
        return this.validator.errors.all();
    }
    parseSchema(schema) {
        return Object.keys(schema).reduce((newSchema, key) => {
            if (schema[key])
                newSchema[key] = schema[key].result;
            return newSchema;
        }, {});
    }
}
export class Rules {
    constructor() {
        this._rules = [];
    }
    get result() {
        return this._rules.join('|');
    }
    get isRequired() {
        return this._rules.indexOf('required') > -1;
    }
    set rules(value) {
        this._rules.push(value);
    }
    accepted() {
        this.rules = 'accepted';
        return this;
    }
    after(date) {
        this.rules = `after:${date}`;
        return this;
    }
    afterOrEqual(date) {
        this.rules = `after_or_equal:date:${date}`;
        return this;
    }
    alpha() {
        this.rules = 'alpha';
        return this;
    }
    alphaDash() {
        this.rules = 'alpha_dash';
        return this;
    }
    array() {
        this.rules = 'array';
        return this;
    }
    before(date) {
        this.rules = `before:${date}`;
        return this;
    }
    beforeOrEqual(date) {
        this.rules = `before_or_equal:date:${date}`;
        return this;
    }
    between(min, max) {
        this.rules = `between:${min},${max}`;
        return this;
    }
    boolean() {
        this.rules = 'boolean';
        return this;
    }
    confirmed() {
        this.rules = 'confirmed';
        return this;
    }
    date() {
        this.rules = 'date';
        return this;
    }
    digits(value) {
        this.rules = `digits:${value}`;
        return this;
    }
    different(field) {
        this.rules = `different:${field}`;
        return this;
    }
    email() {
        this.rules = 'email';
        return this;
    }
    in(array) {
        this.rules = `in:${array}`;
        return this;
    }
    integer() {
        this.rules = 'integer';
        return this;
    }
    max(value) {
        this.rules = `max:${value}`;
        return this;
    }
    min(value) {
        this.rules = `min:${value}`;
        return this;
    }
    notIn(array) {
        this.rules = `not_in:${array}`;
        return this;
    }
    number() {
        this.rules = 'numeric';
        return this;
    }
    required() {
        this.rules = 'required';
        return this;
    }
    requiredIf(anotherfield, value) {
        this.rules = `required_if:${anotherfield},${value}`;
        return this;
    }
    requiredUnless(anotherfield, value) {
        this.rules = `required_unless:${anotherfield},${value}`;
        return this;
    }
    requiredWith(anotherfields) {
        this.rules = `required_with:${anotherfields}`;
        return this;
    }
    requiredWithAll(anotherfields) {
        this.rules = `required_with_all:${anotherfields}`;
        return this;
    }
    requiredWithout(anotherfields) {
        this.rules = `required_without:${anotherfields}`;
        return this;
    }
    requiredWithoutAll(anotherfields) {
        this.rules = `required_without_all:${anotherfields}`;
        return this;
    }
    same(field) {
        this.rules = `same:${field}`;
        return this;
    }
    size(value) {
        this.rules = `size:${value}`;
        return this;
    }
    string() {
        this.rules = 'string';
        return this;
    }
    url() {
        this.rules = 'url';
        return this;
    }
    regex(pattern) {
        this.rules = `regex:${pattern}`;
        return this;
    }
}
export const rules = () => new Rules();



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Validation.ts
// module id = 182
// module chunks = 0